// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"1eeb4b0c","131":"f2435bf6","168":"01ea4756","231":"f3f2964a","385":"ce337d6e","404":"a1928c92","451":"a13080f0","465":"1e57348b","594":"f86a6549","641":"ad9aaa0a","787":"eb293f2a"}[chunkId] + ".chunk.js";
};